module.exports = __webpack_public_path__ + "static/assets/1925d8b95c432baa1abee09a47f5f9ad.mp4";